module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-5-en-CA-f845815852dc567bf02471ea7cc7bd98.png";